export default {
  BALANCE: (state: IPlayerState) => {
    return state.balance;
  },
  USERNAME: (state: IPlayerState) => {
    return state.username;
  },
  VERIFYNAME: (state: IPlayerState) => {
    if (state.verifyName.length > 0) { 
      return state.verifyName;
    }
    //@ts-ignore
    return $cookies.get('qpverifyname')
  },
  ISCLASSIC: (state: IPlayerState) => {
    return state.isClassic
  },
};
